import { createReducer, on } from '@ngrx/store';

import { initialPrescriptionsDraftsState } from './prescriptions-drafts.state';
import {
  addPrescriptionDraft,
  clearPrescriptionDrafts,
  deletePrescriptionDraft,
  loadPrescriptionDraftsFromStorage,
  updatePrescriptionDraft,
} from './prescriptions-drafts.actions';

export const prescriptionsDraftsReducer = createReducer(
  initialPrescriptionsDraftsState,
  on(loadPrescriptionDraftsFromStorage, (state, { drafts }) => ({ ...state, drafts })),
  on(addPrescriptionDraft, (state, { draft }) => ({ ...state, drafts: [...state.drafts, draft] })),
  on(updatePrescriptionDraft, (state, { draft }) => {
    const existingIndex = state.drafts.findIndex(d => d.id === draft.id);
    if (existingIndex !== -1) {
      return { ...state, drafts: state.drafts.map(d => (d.id === draft.id ? { ...d, ...draft } : d)) };
    }
    return { ...state, drafts: [...state.drafts, draft] };
  }),
  on(deletePrescriptionDraft, (state, { id }) => ({
    ...state,
    drafts: state.drafts.filter(d => d.id !== id),
  })),
  on(clearPrescriptionDrafts, state => ({ ...state, drafts: [] }))
);
